exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select2,.select2-dropdown{font-size:1rem!important}#formSummaryStockTable>tbody>tr>td:last-child,#formSummaryStockTable>thead>tr>th:last-child{width:230px;min-width:230px;max-width:230px}#formSummaryStockTable>tbody>tr>td:nth-child(3){padding-left:12px}#formSummaryStockTable .fss-actions{display:flex;flex-wrap:nowrap;justify-content:center;align-items:center}#formSummaryStockTable .fss-action-btn{margin:2px;padding:4px 10px;font-size:.85rem;line-height:1.2;white-space:nowrap}#formSummaryStockTable .fss-expire-line{font-size:.8rem;white-space:nowrap;margin-top:2px}#formSummaryStockTable .fss-expire-warn{color:#fd397a;font-weight:500}#formSummaryStockTable .fss-expire-date{color:#48465b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/PrintSummary/FormSummaryStockList.vue
// module id = 1066
// module chunks = 0